const {REACT_APP_API_BASE_URL} = process.env;

export class UserApi {
    // defualt method for post request
    static PostDefualtMethod = {
        method: 'POST',
        headers: {
            'Content-Type':'application/json'
        },
        credentials: 'include',
        mode: 'cors'
    }

    static GetDefualtMethod = {
        method: 'GET',
        headers: {
            'Content-Type':'application/json'
        },
        credentials: 'include',
        mode: 'cors'
    }

    static register (data) {
        // add url query for prevent register block
        return fetch(`${REACT_APP_API_BASE_URL}/api/me${window.location.search}`, {
            ...UserApi.PostDefualtMethod,
            body: JSON.stringify(data)
        });
    }

    static getData () {
        return fetch(`${REACT_APP_API_BASE_URL}/api/me`, {
            ...UserApi.GetDefualtMethod
        });
    }

    static updateUser (data) {
        return fetch(`${REACT_APP_API_BASE_URL}/api/me`, {
            ...UserApi.GetDefualtMethod,
            method: 'PUT',
            body: JSON.stringify(data)
        });
    }

    /**
     * send multipart form data file
     * @param {FormData} file 
     */
    static uploadLogo (file) {
        return fetch(`${REACT_APP_API_BASE_URL}/api/me/files?upload=logo`, {
            method: 'POST',
            credentials: 'include',
            mode: 'cors',
            body: file
        });
    }

    static deleteLogo() {
        return fetch(`${REACT_APP_API_BASE_URL}/api/me/files?upload=logo`, {
            ...UserApi.PostDefualtMethod,
            method: 'DELETE'
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/user.js